import { render, staticRenderFns } from "./center_10.vue?vue&type=template&id=58d7962f&scoped=true&"
import script from "./center_10.vue?vue&type=script&lang=js&"
export * from "./center_10.vue?vue&type=script&lang=js&"
import style0 from "./center_10.vue?vue&type=style&index=0&id=58d7962f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58d7962f",
  null
  
)

export default component.exports